export default {
  enrichQuestion(question) {
    return question
  }
}